import { render, staticRenderFns } from "./userActionReasonModal.vue?vue&type=template&id=6052ea80&"
import script from "./userActionReasonModal.vue?vue&type=script&lang=js&"
export * from "./userActionReasonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports